import { render, staticRenderFns } from "./PreliminaryReportSummary.vue?vue&type=template&id=58bdb0e2&"
import script from "./PreliminaryReportSummary.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReportSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports